import { DropdownButtonType, List, SingleSelectDropdown, SingleSelectDropdownProps, TextFieldWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../CommonStyles';
import { IReactTranslateService } from '../IReactTranslateService';

export class SiteMembershipFilters extends React.PureComponent<SiteMembershipFiltersProps> {
  public render() {
    let membershipSelectProps: SingleSelectDropdownProps = this.createMembershipSelectDropdownProps();

    return (
      <div style={{ display: 'flex' }}>
        <span style={{ width: 150, flexShrink: 0, marginRight: CommonStyles.Sizes.DefaultSpace }}><SingleSelectDropdown {...membershipSelectProps} /></span>
        <span style={{flexGrow: 1}}>
          <TextFieldWidget
            kind = 'search'
            label = {Messages.search()}
            onChange = {(e) => this.props.onSearchInputTextChange(e.target.value)}
            testId = 'site-membership-search'
            onClear = {this.props.onCancelSearch}
            placeholder = {Messages.searchSites()}
            className = 'tb-membership-search'
            value = {this.props.searchInputText}
          />
        </span>
      </div>
    );
  }

  public createMembershipSelectDropdownProps(): SingleSelectDropdownProps {
    return {
      value: this.props.siteFilterSelection,
      onChange: this.props.onFilterSelected,
      type: DropdownButtonType.Outline,
      testId: 'site-membership-select-DropdownButton',
      list: <List items={this.props.filters.map(value => ({
        value,
        content: this.props.translate(value),
        testId: ['site-membership-select', value, 'MenuItem'].join('-'), // for compatibility with existing automation test
      }))} />,
      label: Messages.site(),
    };
  }
}

export interface SiteMembershipFiltersProps {
  readonly filters: string[];
  readonly onFilterSelected: (value: string) => void;
  readonly siteFilterSelection: string;
  readonly onCancelSearch: () => void;
  readonly onSearchInputTextChange: (value: string) => void;
  readonly searchInputText?: string;
  translate: IReactTranslateService;
}
